if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.mainDetailsToggle = this.mainDetailsToggle || this.querySelector('details');
        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (!this.mainDetailsToggle) {
          return;
        }

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          if (this.elements.shareButton) {
            this.elements.shareButton.classList.remove('hidden');
            this.elements.shareButton.addEventListener('click', () => {
              navigator.share({ url: this.urlToShare, title: document.title }).catch(err => console.error('Share failed:', err));
            });
          }
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          const copyButton = this.mainDetailsToggle.querySelector('.share-button__copy');
          const closeButton = this.mainDetailsToggle.querySelector('.share-button__close');

          if (copyButton) {
            copyButton.addEventListener('click', this.copyToClipboard.bind(this));
          }

          if (closeButton) {
            closeButton.addEventListener('click', this.close.bind(this));
          }
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          if (this.elements.shareSummary) {
            this.elements.shareSummary.focus();
          }
        }
      }

      copyToClipboard() {
        if (!navigator.clipboard) {
          return;
        }
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          if (this.elements.closeButton) {
            this.elements.closeButton.focus();
          }
        }).catch(err => console.error('Copy failed:', err));
      }

      close() {
        this.mainDetailsToggle.open = false;
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton.classList.add('hidden');
        if (this.elements.shareSummary) {
          this.elements.shareSummary.focus();
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) {
          this.elements.urlInput.value = url;
        }
      }
    }
  );
}